import { Link, redirect, useNavigation } from "react-router-dom";
import AuthForm from "../../../components/AuthForm";

import "./LoginRegister.css";
import { API_BASE_URL } from "../../../config";

const fields = [
  {
    label: "Your Name",
    type: "text",
    placeholder: "Full Name",
    name: "name",
  },
  {
    label: "Email",
    type: "email",
    placeholder: "example@email.com",
    name: "email",
  },
  {
    label: "Password",
    type: "password",
    placeholder: "",
    name: "password",
  },
  {
    label: "Repeat Password",
    type: "password",
    placeholder: "",
    name: "password_confirmation",
  },
];

export default function ProffesionalsRegister() {
  const navigation = useNavigation();

  const isSubmitting = navigation.state === "submitting";

  return (
    <section id="login_register">
      <AuthForm
        method="POST"
        title="Register"
        fields={fields}
        buttonText={isSubmitting ? "Registering..." : "Register"}
        googleButtonText="Register via Google"
        roleName="employee"
      >
        <div className="form-auth-message">
          <div className="form-auth-message__text">
            Already Have an account? <Link to="/login">Login Here</Link>
          </div>
        </div>
      </AuthForm>
    </section>
  );
}

export const proffesionalRegisterAction = async ({ request }) => {
  const formData = await request.formData();

  const data = {
    name: formData.get("name"),
    email: formData.get("email"),
    password: formData.get("password"),
    password_confirmation: formData.get("password_confirmation"),
  };

  const response = await fetch(`${API_BASE_URL}/register/employee`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();

  if (result.success === false) {
    return {
      error: result.errors || "Register failed. Please try again",
    };
  }

  localStorage.setItem("token", result.token);
  localStorage.setItem("approved", result.approved);
  localStorage.setItem("role", result.role);
  localStorage.setItem("id", result.id);
  localStorage.setItem("login_time", Date.now());

  if (result.role === "employee") {
    if (result.approved === 0) {
      return redirect("/professionals-approval");
    } else if (result.approved === 2) {
      return redirect("/");
    }
  }
};
